'use strict';

angular.module('imagetrend.components')
    .controller('InspectionVisit', ['$scope', '$stateParams', 'IPVisits', '$state', 'Format', function ($scope, $stateParams, IPVisits, $state, Format) {

        $scope.portal = $state.current.data.isPortal;
        $scope.visit = $stateParams.visit == null ? {} : $stateParams.visit;
        $scope.masterVisit = $stateParams.visit == null ? {} : $stateParams.visit;
        $scope.visitID = $stateParams.id;
        $scope.saving = false;
        $scope.resetting = false;
        $scope.loading = false;
        $scope.isDetailsOpen = true;
        $scope.isInspectionsOpen = true;
        $scope.isAvaliableOpen = true;

        if ($stateParams.id != null) {
            $scope.loading = true;

            IPVisits.getByID($stateParams.id).then(function (visit) {
                for (var i = visit.service.vehicles.length - 1; i >= 0; i--) {
                    if (visit.service.vehicles[i].expiration_date != null) {
                        visit.service.vehicles[i].expiration_date = new Date(visit.service.vehicles[i].expiration_date).toLocaleString([], Format.nativeJSDateFormat('MM/DD/YY'));
                    }
                }

                $scope.visit = visit;
                if (visit.date_time_set) {
                    $scope.visit.inspection_date_time = angular.copy($scope.visit.inspection_date);
                }
                $scope.masterVisit = angular.copy($scope.visit);
                $scope.loading = false;
            });
        }
        else {
            if ($scope.portal) {
                $state.go('portal.menus.denied');
            }
            else {
                $state.go('internal.inspecting.denied');
            }
        }

        $scope.save = function () {
            $scope.saving = true;

            $scope.visit.Date_Time_Set = ($scope.visit.inspection_date_time != null);
            IPVisits.save($scope.visit).then(function (visit) {
                if (visit != null) {
                    $scope.visit = visit;
                    if (visit.date_time_set) {
                        $scope.visit.inspection_date_time = angular.copy($scope.visit.inspection_date);
                    }
                    $scope.masterVisit = angular.copy($scope.visit);
                }

                $scope.saving = false;
            })
        }

        $scope.addInspector = function (visit) {
            if (visit.inspector != null) {
                visit.inspectors.push(angular.copy(visit.inspector));
                visit.inspector = null;
                visit.newInspector = false;
            }
        }

        $scope.remove = function (array, item) {
            array.splice(array.indexOf(item), 1);
        }

        $scope.addService = function (visit) {
            visit.inspections.push({ service_id: visit.service_id, type: 'service', name: visit.service.name });
        }

        $scope.addVehicle = function (visit, vehicle) {
            visit.inspections.push({ vehicle_id: vehicle.id, service_id: visit.service_id, type: 'vehicle', name: vehicle.serial_number });
        }

        $scope.filterAdded = function (item) {
            var show = true;

            if ($scope.visit.inspections != null) {
                $scope.visit.inspections.forEach(function (i) {
                    if (i.vehicle_id == item.id) {
                        show = false;
                    }
                })
            }

            return show;
        }

        $scope.isServiceAvailable = function (visit) {
            var show = true;

            if (visit.inspections != null) {
                visit.inspections.forEach(function (i) {
                    if (i.service_id == visit.service_id && i.vehicle_id == null) {
                        show = false;
                    }
                });
            }

            return show;
        }

        $scope.reset = function () {
            $scope.resetting = true;
            $scope.visit = angular.copy($scope.masterVisit);
            $scope.resetting = false;
        }

        $scope.setInspectionTime = function (time) {
            if (time != null && isValidDate(time)) {
                if ($scope.visit.inspection_date == null) {
                    $scope.visit.inspection_date = new Date();
                }
                $scope.visit.inspection_date.setHours(time.getHours());
                $scope.visit.inspection_date.setMinutes(time.getMinutes());
            }
        };
    }])
    ;